var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.156 13.5518C8.899 12.0178 12 8.88381 12 6.00781C12 4.41651 11.3679 2.89039 10.2426 1.76517C9.11742 0.639953 7.5913 0.0078125 6 0.0078125C4.4087 0.0078125 2.88258 0.639953 1.75736 1.76517C0.632141 2.89039 2.37122e-08 4.41651 0 6.00781C0 8.88381 3.1 12.0178 4.844 13.5518C5.16211 13.8358 5.5736 13.9927 6 13.9927C6.4264 13.9927 6.83789 13.8358 7.156 13.5518ZM4 6.00781C4 5.47738 4.21071 4.96867 4.58579 4.5936C4.96086 4.21853 5.46957 4.00781 6 4.00781C6.53043 4.00781 7.03914 4.21853 7.41421 4.5936C7.78929 4.96867 8 5.47738 8 6.00781C8 6.53825 7.78929 7.04695 7.41421 7.42203C7.03914 7.7971 6.53043 8.00781 6 8.00781C5.46957 8.00781 4.96086 7.7971 4.58579 7.42203C4.21071 7.04695 4 6.53825 4 6.00781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.0e51b6fa66683fafc4dd3298a83567d9.svg";
export { ForwardRef as ReactComponent };